// extracted by mini-css-extract-plugin
export default {"chat-container":"styles_chat-container__hdCDO","download-code-btn":"styles_download-code-btn__+gVq4"};